import { useEffect, useState } from 'preact/hooks';
import { PlayButton } from './play-button/play-button';
import { IndexButton } from './index-button/index-button';
import { SettingsButton } from './settings-button/settings-button';
import { Book, Chapter } from '../../types';
import { BackButton } from './back-button/back-button';
import { HomeButton } from './home-button/home-button';
import { NextButton } from './next-button/next-button';
import { EditButton } from './edit-button';
import { ThemeToggle } from './theme-toggle/theme-toggle';
import { FavouriteButton } from './favourite-button/favourite-button';
// import { LibraryButton } from './buttons/library-button';
import { CommentsButton } from './comments-button';

import './header.css';
import { User } from '@novelizing/types';

interface HeaderProps {
  chapter?: Chapter;
  prevChapter?: Chapter;
  nextChapter?: Chapter;
  book: Book;
  onToggleChapterList: () => void;
  onToggleSettings: () => void;
  onToggleComments: () => void;
  canEdit: boolean;
  onToggleTTS: () => void;
  isPlaying: boolean;
  user: User;
}

export const Header = ({
  prevChapter,
  nextChapter,
  book,
  chapter,
  onToggleChapterList,
  onToggleSettings,
  onToggleComments,
  user,
  canEdit,
  onToggleTTS,
  isPlaying,
}: HeaderProps) => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    let lastScrollPosition = window.scrollY;

    const handleScroll = () => {
      const currentScrollPosition = window.scrollY;

      if (
        currentScrollPosition > lastScrollPosition &&
        currentScrollPosition > 40
      ) {
        // Scrolling down - hide header
        setIsHidden(true);
      } else if (currentScrollPosition < lastScrollPosition) {
        // Scrolling up - show header
        setIsHidden(false);
      }

      lastScrollPosition = currentScrollPosition;
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup listeners on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`sticky ${isHidden ? 'hidden' : ''}`}>
      <nav className="top-nav">
        <ul className="navigation">
          <li>
            <HomeButton />
          </li>
          {chapter && (
            <>
              <li>
                <BackButton prevChapter={prevChapter} book={book} />
              </li>
              <li>
                <NextButton nextChapter={nextChapter} book={book} />
              </li>
              {canEdit && (
                <li>
                  <EditButton chapter={chapter} book={book} />
                </li>
              )}
            </>
          )}
        </ul>

        <ul className="utils">
          <li>
            <PlayButton onToggleTTS={onToggleTTS} isPlaying={isPlaying} />
          </li>
          <li>
            <IndexButton onClick={onToggleChapterList} />
          </li>
          <li>
            <SettingsButton onClick={onToggleSettings} />
          </li>
          <li className="theme-toggle">
            <ThemeToggle />
          </li>
        </ul>
      </nav>

      <nav className="bottom-nav">
        <ul>
          <li>
            <FavouriteButton
              bookId={book.id}
              chapterId={chapter?.id}
              userId={user?.id}
            />
          </li>
          {/* <li>
              <LibraryButton />
            </li> */}
          <li>
            <CommentsButton
              onClick={onToggleComments}
              entityId={`chapter-${chapter?.id}`}
            />
          </li>
        </ul>
      </nav>
    </header>
  );
};
